import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Skeleton from '@mui/material/Skeleton';
import React, { useEffect, useState } from 'react';

function LinearDeterminate(props: {speed: number}) {
  const {speed} = props;
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * speed;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress variant="determinate" value={progress} />
    </Box>
  );
}


export default function MessageViewLoading(props: {showSkeletons: boolean}) {
  const {showSkeletons} = props;
  return (
    <Grid
      container
      direction="column"
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: (theme) => theme.palette.background.paper
      }}
      wrap="nowrap"
      justifyContent="space-between"
      alignItems="stretch"
    >
      {showSkeletons && <Grid container direction="column" wrap="nowrap">
        <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row-reverse" wrap="nowrap">
          <Skeleton variant="rectangular" width="100%" height={80} style={{margin: 6, borderRadius: 5}}/>
          <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
        </Grid>
        <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row" wrap="nowrap">
          <Skeleton variant="rectangular" width="100%" height={100} style={{margin: 6, borderRadius: 5}}/>
          <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
        </Grid>
        <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row-reverse" wrap="nowrap">
          <Skeleton variant="rectangular" width="100%" height={95} style={{margin: 6, borderRadius: 5}}/>
          <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
        </Grid>
        <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row" wrap="nowrap">
          <Skeleton variant="rectangular" width="100%" height={120} style={{margin: 6, borderRadius: 5}}/>
          <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
        </Grid>
      </Grid>}
      <LinearDeterminate speed={5}/>
    </Grid>
  );
}
